import * as LatLng from './LatLng';
import * as LatLngBounds from './LatLngBounds';

export default { LatLng, LatLngBounds };